var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full md:w-3/3 mb-5"},[_c('vx-card',[_c('h1',[_vm._v("ยินดีต้อนรับสู่ระบบ World Educational Loan Services")])])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }